import { Hourglass } from "lucide-react";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { CreateBreakoutSessionsFormData } from "../types/create-breakout-sessions.schema";

export function TimerElement() {
  const [isTimerModalOpen, setIsTimerModalOpen] = useState(false);

  const form = useFormContext<CreateBreakoutSessionsFormData>();

  const handleApplyTimer = () => {
    setIsTimerModalOpen(false);
  };

  return (
    <div className="flex flex-col">
      <Label className="mb-1.5">Timer</Label>

      <Dialog open={isTimerModalOpen} onOpenChange={setIsTimerModalOpen}>
        <DialogTrigger asChild>
          <Button variant="ghost" size="icon" className="size-10" type="button">
            <Hourglass />
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-xl" aria-describedby={undefined}>
          <DialogHeader>
            <DialogTitle>Set a timer</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <p className="text-sm text-muted-foreground">
              End breakout rooms after a set amount of time?
            </p>
            <FormField
              control={form.control}
              name="timer"
              render={({ field }) => (
                <FormItem>
                  <Label isRequired>Minutes</Label>
                  <FormControl>
                    <Input
                      min={1}
                      className="max-w-24"
                      type="number"
                      {...field}
                      value={field.value ?? ""}
                      onBlur={() => form.trigger("timer")}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </DialogBody>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setIsTimerModalOpen(false)}
            >
              Cancel
            </Button>
            <Button onClick={handleApplyTimer} isAnimated>
              Apply Timer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
